import React from 'react';
import logo from './logo.svg';
import { BrowserRouter as Router, HashRouter, Route, Link, Switch } from 'react-router-dom';
import './App.css';

import Home from './components/Home';
import Cgu from './components/Cgu';
import Contact from './components/Contact';

function App() {
  return (
    <Switch>
        <div>
          <h2>Muffin</h2>
          <nav className="navbar navbar-expand-lg navbar-light bg-light">
          <ul className="navbar-nav mr-auto">
            <li><Link to={'/'} className="nav-link"> Home </Link></li>
            <li><Link to={'/contact'} className="nav-link">Contact</Link></li>
            <li><Link to={'/cgu'} className="nav-link">Cgu</Link></li>
          </ul>
          </nav>
          <hr />
          {/* <Switch> */}
              <Route exact path='/' component={Home} />
              <Route exact path='/contact' component={Contact} />
          {/* </Switch> */}
          {/* <HashRouter> */}
              <Route path='/cgu' component={Cgu} />
          {/* </HashRouter> */}
        </div>
      </Switch>
  );
}

export default App;
